import { notifyError } from "@src/shared/notify";
import { QueryClient } from "react-query";
import { z } from "zod";

const errorSchema = z.object({ message: z.string() });
export function handleQueryError(err: unknown) {
  console.log(err);
  const zError = errorSchema.safeParse(err);
  if (zError.success) {
    console.log(zError.data.message);
    notifyError(zError.data.message);
  } else notifyError("Could not complete requested query");
}

export function handleMutationError(err: unknown) {
  console.log(err);
  const zError = errorSchema.safeParse(err);
  if (zError.success) notifyError(zError.data.message);
  else notifyError("Could not complete requested update");
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      onError: handleQueryError,
    },
    mutations: {
      onError: handleMutationError,
    },
  },
});
